import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';

import PlaceList from '../components/PlaceList';
import ErrorModal from '../../shared/components/UIElements/ErrorModal';
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner';
import { useHttpClient } from '../../shared/hooks/http-hook';

const UserPlaces = () => {
  const [loadedPlaces, setLoadedPlaces] = useState();
  const { isLoading, error, sendRequest, clearError } = useHttpClient();

  const userId = useParams().userId;
  const history = useHistory();

  useEffect(() => {
    const fetchPlaces = async () => {
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_URL}/api/places/user/${userId}`
        );
        setLoadedPlaces(responseData.places);
      } catch (err) { }
    };
    fetchPlaces();

  }, [sendRequest, userId]);

  const placeDeletedHandler = (deletedPlaceId) => {
    setLoadedPlaces(prevPlaces =>
      prevPlaces.filter(place => place.id !== deletedPlaceId)
    );
  };

  const errorHandler = () => {
    clearError();
    // Redirect if it's the "No places found" error, or generally for simplification on this page
    if (error === 'No places found for this user.') {
      history.push('/');
    }
  };

  return (
    <React.Fragment>
      <ErrorModal
        error={error}
        onClear={errorHandler}
        header={error === 'No places found for this user.' ? 'No Places Found' : undefined}
      />
      {isLoading && (
        <div className='center'>
          <LoadingSpinner />
        </div>
      )}
      {!isLoading && loadedPlaces && (
         <div className="place-list-container">
           <div style={{ textAlign: 'right', width: '90%', maxWidth: '40rem', margin: '1rem auto 0 auto' }}>
              <button 
                 onClick={() => history.push('/')}
                 style={{
                   background: 'transparent', border: 'none', color: 'white', 
                   fontSize: '2rem', cursor: 'pointer', padding: '0.5rem'
                 }}
                 title="Close"
              >
                  &#x2715;
              </button>
           </div>
           <PlaceList items={loadedPlaces} onDeletePlace={placeDeletedHandler} />
         </div>
      )}
    </React.Fragment>
  )
}

export default UserPlaces;